import React, { useEffect } from 'react'
import Helmet from 'react-helmet'
import { useIntl } from 'react-intl'
import LoginContainer from 'components/LoginContainer/LoginContainer'
import LoginForm from 'components/LoginForm/LoginForm'
import { useMobileContext } from 'context/MobileContext'

const Login = () => {
  const title = useIntl().formatMessage({ id: 'Login.title' }, { 0: process.env.REACT_APP_PAGE_TITLE })
  const { setShowBackButton } = useMobileContext()

  useEffect(() => {
    setShowBackButton(false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <LoginContainer>
        <LoginForm />
      </LoginContainer>
    </>
  )
}

export default Login
